class V2IframeServiceClass {
  getv2iFrameUrl() {
    return window.SS_GLOBALS.frontEndConfig.v2IframeUrl;
  }
}

export const V2IframeService = new V2IframeServiceClass();
